import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchStats } from '../api/giving'
import type { CampaignStats } from '../api/giving'

interface CampaignContextValue {
  stats: CampaignStats
  isLoading: boolean
}

const defaultStats: CampaignStats = {
  total_raised: 0,
  donor_count: 0,
  goal: 0,
}

const CampaignContext = createContext<CampaignContextValue>({
  stats: defaultStats,
  isLoading: true,
})

export const CampaignProvider = ({ children }: { children: ReactNode }) => {
  const { data, isLoading } = useQuery({
    queryKey: ['campaign-stats'],
    queryFn: fetchStats,
    refetchInterval: 30_000,
    staleTime: 25_000,
  })

  return (
    <CampaignContext.Provider value={{ stats: data ?? defaultStats, isLoading }}>
      {children}
    </CampaignContext.Provider>
  )
}

export const useCampaign = () => useContext(CampaignContext)
